import { render, staticRenderFns } from "./DownloadZone.vue?vue&type=template&id=207d120a&scoped=true&"
import script from "./DownloadZone.vue?vue&type=script&lang=js&"
export * from "./DownloadZone.vue?vue&type=script&lang=js&"
import style0 from "./DownloadZone.vue?vue&type=style&index=0&id=207d120a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d120a",
  null
  
)

export default component.exports